import { Message } from 'element-ui'

// Header导航栏页面更改
function openPage(router, path) {
  router.push({
    path: path
  })
}

// 检测竞赛是否存在
function checkComp(router,compId,http){
    var compInfo = {
            compId
    }
    http.getComp(compInfo).then((res)=>{
        console.log(res)
        if (res.status === 0) {
            //存在竞赛 但是要检测是否正式上线
            if (res.data.online === true) {
                //正式上线 可以显示页面
            }else {
                // 未正式上线，需要拦截等操作，跳转404
                Message.warning("该竞赛还未上线");
                //TODO: 可添加判断是否为白名单用户进行测试工作
                router.push({
                    path: '/404'
                });
            }

        }else {
            // 不存在该竞赛 提示 并跳转404
            Message.warning("不存在该竞赛");
            router.push({
                path: '/404'
            });
        }
    })


}

export default {
    openPage,
    checkComp
}
